import {
  LANGUAGE,
  LOCAL_DEFAULT_CONFIG,
  PANES_CACHE,
  PANES_HISTORY_CACHE,
  ACTIVE_KEY_CACHE
} from '@/store/mutation-types'
import { TransformLogin } from '@/api/sso/user'
import { QueryPageBindDocument } from '@/api/index'

export function getObjBykeys (obj, keys = [], initialValue = {}) {
  const value = {}
  keys.forEach(key => {
    value[key] = obj[key] || undefined
  })
  return { ...value, ...initialValue }
}

export function getMenus (data, config, deep = 0) {
  if (!data || !data.length) {
    return []
  }

  const menus = data
    .filter(find => (find.platformCode === 'SSO_SYS_USER_BASE' ? find.selectFlag === 2 : true))
    .map((menu) => {
    let key = `m_${menu.menuId}`
    const menuName = {
      'zh_CN': menu.menuName,
      'en_US': menu.menuEnName,
      'ko_KR': menu.menuKrName
    }
    const deepLevel = deep
    const tab = menuName[config.lang] || menuName['zh_CN'] || key
    // const childMenus = (menu.lastMenu === 2 && []) || (menu.childMenus && getMenus(menu.childMenus, config, deep + 1))
    const childMenus = ((menu.lastMenu === 2 && menu.platformCode !== 'SSO_SYS_USER_BASE') && []) || (menu.childMenus && getMenus(menu.childMenus, config, deep + 1))
    // const special = (!childMenus.some(find => find.special === 2) && deepLevel < 3) ? 1 : 2
    const special = menu.special || 1
    const assetsType = menu.assetsType || undefined
    const icon = (menu?.menuIcon || '').replace(/^http:\/\//, window.location.protocol + '//') || (menu.lastMenu === 1 ? 'thunderbolt' : '')
    const pushpin = menu.collectFlag && menu.collectFlag === 2
    const tabVisible = typeof config.tabVisible === 'boolean' ? config.tabVisible : true
    let updateFlag = !childMenus.length ? menu.updateFlag : (childMenus.some(so => so.updateFlag === 1) ? 1 : 2)
    let systemDomain = '' // 域名
    let systemCode = menu.systemCode
    let menuUrl = '' // 路径
    let path = `/entry/${config.serviceId}/${config.systemCode}` // 动态路由
    let functionClass = []
    if (menu.lastMenu === 2 || menu.menuType === 2) {
      functionClass = menu.functionClass
    }
    // 处理跳转URL地址
    if (menu.platformCode === 'SSO_SYS_USER_BASE' && menu.lastMenu === 2 && !menu.menuUrl?.startsWith('http')) {
      menuUrl = menu['menuUrl'] || ''
      updateFlag = 1
      path += `/sso-web#${menuUrl}`
      systemCode = 'SSO_SYS_USER'
    } else if (menu.menuUrl?.startsWith('http')) {
      systemDomain = new URL(menu.menuUrl).origin
      menuUrl = `${menu.menuUrl}`
      path += `/iframe#/${key}`
      if (menu.systemCode === 'SAAS_PLATFORM_AUTH') {
        menuUrl = `${menu.menuUrl.replace(/^(.*?)#/, window.location.protocol + '//' + window.location.host + '/#')}`
      }
    } else if (menu.systemDomain) {
      systemDomain = menu.systemDomain.startsWith('http') ? menu.systemDomain : `${window.location.protocol}//${menu.systemDomain}`
      menuUrl = `${systemDomain}${menu.menuUrl}`
      path += `/iframe#/${key}`
    } else {
      const appConfig = config.microApps.find(item => item.systemCode === menu.systemCode)
      systemDomain = ''
      menuUrl = menu.menuUrl
      path += appConfig ? `/${appConfig.name}#${menu.menuUrl}` : '/404'
    }

    // 特殊处理home.proxy.eccang.com
    if (['home.proxy.eccang.com', 'pre-home.proxy.eccang.com'].includes(window.location.host)) {
      menuUrl = menuUrl?.replace(/.eccang.com/i, '.proxy.eccang.com')
    }

    return getObjBykeys(
      menu,
      ['menuId', 'platformExpireTime', 'assetsExpireTime', 'lastMenu', 'updatePackageIds', 'relationMenuList', 'topicList', 'agentId', 'useTopic', 'menuType'],
      { key, tab, systemDomain, icon, menuUrl, path, menuName, childMenus, special, pushpin, assetsType, tabVisible, closable: true, hidden: config.hidden || false, updatePackageId: config.packageId, updateFlag, deepLevel, functionClass, systemCode }
    )
  })

  return menus
}

const paneKeys = [
  'key',
  'tab',
  'systemDomain',
  'path',
  'menuType',
  'menuId',
  'menuName',
  'lastMenu',
  'icon',
  'menuUrl',
  'relationMenuList',
  'agentId',
  'topicList',
  'useTopic',
  'platformExpireTime',
  'assetsExpireTime',
  'assetsType',
  'pushpin',
  'hidden',
  'functionClass'
]

export function findPane (menus = [], target, config = {}, plusPaneKeys = []) {
  if (!menus || !menus.length) return undefined
  let pane
  const targetKeys = Object.keys(target)
  const targetString = JSON.stringify(target)
  const defaultConfig = { closable: true }
  config = { ...defaultConfig, ...config }

  menus.forEach(menu => {
    const menuObject = getObjBykeys(menu, targetKeys)
    const menuString = JSON.stringify(menuObject)

    if (pane) {

    } else if (targetString === menuString) {
      pane = getObjBykeys(menu, [...plusPaneKeys, ...paneKeys], { ...config })
    } else if (menu.childMenus && menu.childMenus.length && findPane(menu.childMenus, target)) {
      pane = findPane(menu.childMenus, target, { ...config }, plusPaneKeys)
    }
  })

  return pane
}

export function filterPane (menus, target, config = { closable: true }) {
  if (!menus || !menus.length) return []

  const panes = []
  const targetKeys = Object.keys(target)
  const targetString = JSON.stringify(target)

  menus.forEach(menu => {
    const menuObject = getObjBykeys(menu, targetKeys)
    const menuString = JSON.stringify(menuObject)

    if (targetString === menuString) {
      panes.push(getObjBykeys(menu, paneKeys, { ...config }))
    } else if (menu.childMenus && menu.childMenus.length) {
      panes.push(...filterPane(menu.childMenus, target, { ...config }))
    }
  })

  return panes
}

/**
 * 过滤子菜单
 * @param {Array} menus 菜单列表
 * @param {Object} target 过滤条件
 * @param {Object} parentMenu 父菜单
 * @returns {Array} 子菜单列表
 */
export function filterSubMenus (menus, target = { menuType: 2 }, parentMenu = {}) {
  if (!menus || !menus.length) return []

  const subMenus = []
  const targetKeys = Object.keys(target)
  const targetString = JSON.stringify(target)

  menus.forEach((menu, index) => {
    const menuObject = getObjBykeys(menu, targetKeys)
    const menuString = JSON.stringify(menuObject)

    if (targetString === menuString) {
      const subMenu = {
        agentId: undefined,
        assetsExpireTime: undefined,
        assetsType: undefined,
        closable: true,
        functionClass: menu.functionClass,
        hidden: undefined,
        icon: undefined,
        key: `m_${parentMenu.menuId}_${index}`,
        lastMenu: 2,
        menuType: 2,
        menuId: parentMenu.menuId,
        menuName: {
          'zh_CN': `${parentMenu.menuName} - ${menu.menuName}`,
          'en_US': `${parentMenu.menuName} - ${menu.menuEnName || menu.menuName}`,
          'ko_KR': `${parentMenu.menuName} - ${menu.menuKrName || menu.menuName}`
        },
        menuUrl: parentMenu.menuUrl,
        path: parentMenu.menuUrl,
        platformExpireTime: undefined,
        pushpin: undefined,
        raw: menu,
        relationMenuList: undefined,
        systemCode: parentMenu.systemCode,
        systemDomain: undefined,
        tab: `${parentMenu.menuName} - ${menu.menuName}`,
        topicList: undefined,
        useTopic: undefined
      }

      subMenus.push(subMenu)
    } else if (menu.childMenus && menu.childMenus.length) {
      const { childMenus, ...rest } = menu
      subMenus.push(...filterSubMenus(childMenus, target, rest))
    }
  })

  return subMenus
}

/**
 * 清除本地存储
 * @param vm Vue实例
 * @param options.clearAll 默认为`false`，只调用`Vue.ls.clear()`，为`true`时清除所有不是`app-`开头的项
 */
export function clearVueLs (vm, options) {
  let activeKey
  if (/redirectPath=/g.test(window.location.search)) {
    activeKey = vm.ls.get(ACTIVE_KEY_CACHE)
  }
  const lang = vm.ls.get(LANGUAGE)
  const config = vm.ls.get(LOCAL_DEFAULT_CONFIG) || {}
  const panes = vm.ls.get(PANES_CACHE)
  const panesHistory = vm.ls.get(PANES_HISTORY_CACHE)
  const selmuchStatus = localStorage.getItem('selmuch_status')
  // 临时豁免，2个月左右下掉
  const SaveTipRecordToken = localStorage.getItem('SaveTipRecordToken') || ''
  config.lite = {}
  if (options?.clearAll) {
    for (const key of Object.keys(localStorage)) {
      // vxetable 的列宽存储默认使用的键
      if (key === 'VXE_TABLE_CUSTOM_COLUMN_WIDTH') continue
      if (!key.startsWith('app-')) {
          localStorage.removeItem(key)
      }
    }
  }
  vm.ls.clear()
  vm.ls.set(LANGUAGE, lang)
  vm.ls.set(LOCAL_DEFAULT_CONFIG, config)
  vm.ls.set(PANES_CACHE, panes)
  vm.ls.set(PANES_HISTORY_CACHE, panesHistory)
  activeKey && vm.ls.set(ACTIVE_KEY_CACHE, activeKey)
  localStorage.setItem('selmuch_status', selmuchStatus)
  localStorage.setItem('SaveTipRecordToken', SaveTipRecordToken)
}
 // 文档跳转路径判断
export function documentChangeUrl (vm, menuId, config = {}) {
  const { params: { serviceId, systemCode } } = vm.$route
  QueryPageBindDocument({ menuId: menuId }).then(({ data }) => {
    if (data?.platformType === 'SSO_SYS_USER') {
      return vm.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/company/helper/center?docId=${data?.documentId}`,
        ...config
      })
    } else if (data?.platformType === 'OPEN_API_PORTAL') {
      TransformLogin({
        targetPlatformCode: 'OPEN_API_PORTAL'
      }).then(res => {
        return window.open(`//${this.$env === 'development' ? 'testnew-' : this.$env === 'preview' ? 'pre-' : ''}open.eccang.com/#/DocumentCenter?token=${res.data}&docId=${data?.documentId}`)
      })
    } else {
      // vm.$winOpen(`/#/middleware?toHelp=true&id=` + menuId)
      return vm.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/company/helper/center`,
        ...config
      })
    }
  })
}
